<ng-container *ngIf="appointment">
  <ng-container *ngIf="!workflow; else workflowTemplate">
    <button
      *appHasPermission="[Permission.APPOINTMENT_INTAKE_VIEW, Permission.APPOINTMENT_INTAKE_CREATE]"
      mat-icon-button
      [matTooltip]="intakeStatusText(appointment.intakeStatus) | translate: { value: appointment.intakeProgress || 0 }"
      [matMenuTriggerFor]="intakeMenu"
      (click)="$event.stopPropagation()"
      matTooltipPosition="above"
    >
      <mat-progress-spinner
        *ngIf="inProgress"
        diameter="30"
        mode="indeterminate"
      ></mat-progress-spinner>
      <mat-icon *ngIf="!inProgress" [ngClass]="intakeStatusColor(appointment.intakeStatus)">
        <ng-container
          *ngIf="appointment.intakeStatus === INTAKE_STATUS.SYNCED else assignmentTurnedIcon">
          note_alt
        </ng-container>
        <ng-template #assignmentTurnedIcon>assignment</ng-template>
      </mat-icon>
    </button>

    <mat-menu #intakeMenu="matMenu">
      <button
        mat-menu-item
        *ngIf="canSendIntakeLinkToPatient"
        [matMenuTriggerFor]="intakeSendMenu"
      >
        <mat-icon>send</mat-icon>
        <span>Send to patient</span>
      </button>
      <button mat-menu-item *ngIf="!appointment.intakeId" (click)="startIntake()">
        <mat-icon>add</mat-icon>
        <span>{{ 'patient-details.intake-card.button-fill-out' | translate }}</span>
      </button>
      <button
        mat-menu-item
        *ngIf="canSendIntakeLinkToPatient"
        (click)="generateCode()"
      >
        <mat-icon>vpn_key</mat-icon>
        <span>Generate code</span>
      </button>
      <button mat-menu-item *ngIf="appointment.intakeId" (click)="gotoIntake()">
        <mat-icon>launch</mat-icon>
        <span>View intake</span>
      </button>
      <button
        mat-menu-item
        *ngIf="appointment.intakeId"
        [matMenuTriggerFor]="intakeDownloadMenu"
        (menuOpened)="downloadMenuOpened()"
      >
        <mat-icon>print</mat-icon>
        <span>Print</span>
      </button>
    </mat-menu>

    <mat-menu #intakeSendMenu="matMenu">
      <button mat-menu-item [disabled]="!patient?.canText" (click)="openSendMessageConfirmationDialog('sms')">
        {{ 'common.send-via.text' | translate }}
      </button>
      <button mat-menu-item [disabled]="!patient?.canEmail" (click)="openSendMessageConfirmationDialog('email')">
        {{ 'common.send-via.email' | translate }}
      </button>
    </mat-menu>

    <mat-menu #intakeDownloadMenu="matMenu">
      <button
        mat-menu-item
        (click)="download($event, 'combined')"
        matTooltip="Registration, Questionnaire, Consents, and Patient-Uploaded Photos"
      >
        Combined with photos
      </button>
      <button
        mat-menu-item
        (click)="download($event, 'combined-without-photos')"
        matTooltip="Registration, Questionnaire &amp; Consents"
      >
        Combined without photos
      </button>
      <button mat-menu-item (click)="download($event, 'intake')">
        Registration &amp; Questionnaire
      </button>
      <button mat-menu-item (click)="download($event, 'registration')">
        Registration
      </button>
      <button mat-menu-item (click)="download($event, 'questionnaire')">
        Questionnaire
      </button>
      <button mat-menu-item *ngIf="inProgress && intake == null">
        Loading intake…
      </button>
      <button
        mat-menu-item
        (click)="download($event, 'combined-consents')"
        *ngIf="intake?.consents && intake?.consents.length > 1"
      >
        Combined Consents
      </button>
      <ng-container *ngIf="intake?.consents && intake?.consents.length > 0">
        <button
          mat-menu-item
          *ngFor="let consent of intake.consents"
          (click)="download($event, 'consent.' + consent.id)"
          [matTooltip]="consent.title"
        >
          Consent: {{ consent.title }}
        </button>
      </ng-container>
    </mat-menu>
  </ng-container>
  <ng-template #workflowTemplate>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
      <mat-icon
        [ngClass]="intakeStatusColor(appointment.intakeStatus)"
        fxFlex="25px"
      >
        <ng-container
          *ngIf="appointment.intakeStatus === INTAKE_STATUS.SYNCED else assignmentTurnedIcon">
          note_alt
        </ng-container>
        <ng-template #assignmentTurnedIcon>assignment</ng-template>
      </mat-icon>
      <span>{{ intakeStatusText(appointment.intakeStatus) | translate: { value: appointment.intakeProgress || 0 } }}</span>
    </div>
  </ng-template>
</ng-container>

<button *ngIf="status" mat-stroked-button>
  <mat-icon [ngClass]="intakeStatusColor(this.status)">
    <ng-container
      *ngIf="status === INTAKE_STATUS.SYNCED else assignmentTurnedIcon1">
      note_alt
    </ng-container>
    <ng-template #assignmentTurnedIcon1>assignment</ng-template>
  </mat-icon>
  {{ intakeDisplayStatus(status) | translate }}
</button>
